$(document).ready(function(){

  if( $('body').attr('id') === 'digital-gift-card' ){

    $('body').on('change', '.variants [type="radio"]', function(e){
      e.preventDefault();

      let selectedTitle = [];
      $('.variants [type="radio"]:checked').each(function(){
        selectedTitle.push($(this).val());
      })

      let activeVariant = productJson.variants.find(variant => {
        return variant.title === selectedTitle.join(' / ')
      });

      $('#variant-selector').val(activeVariant.id);
      $('#gift-card-image').attr('src', activeVariant.featured_image.src).attr('alt', activeVariant.featured_image.alt);

	  if (history.replaceState) {
		  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + activeVariant.id
		  window.history.replaceState({ path: newurl }, '', newurl)
		  sessionStorage.setItem('lo-back-to', newurl) // for use in the cart
	  }

    });

  }

  if( $('body').attr('id') === 'gift-card' ){

    $('body').on('click', '.variants .btn', function(e){
      e.preventDefault();
      $(this).siblings('.btn').removeClass('selected');
      $(this).addClass('selected');

      let selectedTitle = [];
      $('.variants .btn.selected').each(function(){
        selectedTitle.push($(this).text());
      })

      let activeVariant = productJson.variants.find(variant => {
        return variant.title === selectedTitle.join(' / ')
      });

      $('#variant-selector').val(activeVariant.id);

    });

  }
  
});
